// extracted by mini-css-extract-plugin
export default {"halloween-video-bg":"halloween-video-bg--2FJaq"};
    if(module.hot) {
      // 1747648171131
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  